import React, {useCallback, useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {changePageTitle} from "../typescript/redux/actions";
import {Delete as DeleteIcon} from "@mui/icons-material";
import {Datatable} from "../index";
import {LaboratoryService} from "./laboratory.service";
import {useNavigate} from "react-router-dom";

export function LaboratoryList() {

    let navigate = useNavigate();
    const [pageParams, setPageParams] = useState(null);
    const dispatch = useDispatch();

    const findAll = useCallback(async (number, size, sort, filter) => {
        const items = await LaboratoryService.findAll(number, size, sort, filter);
        setPageParams({
            number: number,
            size: size,
            sort: sort,
            filter: filter,
            items: items
        });
    }, []);

    useEffect(() => {
        dispatch(changePageTitle("Laboratórios"));
        findAll(0, parseInt(process.env.REACT_APP_PAGE_SIZE), "id,asc", '').then();
    }, [dispatch, findAll]);

    const editItem = (item) => {
        navigate('/laboratory/' + item.id);
    }

    const insertItem = () => {
        navigate('/laboratory');
    }

    const deleteItem = (item) => {
        LaboratoryService.delete(item.id).then(() => {
            findAll(pageParams.number, pageParams.size, pageParams.sort, pageParams.filter).then();
        }).catch(() => {

        })
    }

    const headerOperations = [
        {color: () => "primary", onClick: insertItem, label: () => 'Inserir'}
    ]

    const rowOperations = [
        {color: () => "primary", onClick: deleteItem, label: () => 'Excluir', icon: () => <DeleteIcon/>},
    ]

    return pageParams && (
        <Datatable dataColumnNames={['ID', 'Descrição', 'CNPJ']} dataColumns={['id', 'description', 'cnpj']}
                   number={pageParams.number} size={pageParams.size} sort={pageParams.sort} filter={pageParams.filter}
                   dataTypes={['number', 'text', 'text']} findAll={findAll} editData={editItem}
                   data={pageParams.items.content} totalData={pageParams.items.totalElements}
                   headerOperations={headerOperations} rowOperations={rowOperations}/>
    );
}